<h3>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(uploadToggle)"  (click)="displayUpload()" id="stock_mod_button">Upload File</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(masterSheetToggle)" (click)="displayMasterSheet()">Master Sheet</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(leadsToggle)" (click)="displayNewLeads()">Leads</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(ecmsToggle)" (click)="displayECMS()">ECMS</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(reportsToggle)" (click)="displayReports()">GeoPal Reports</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(issuesToggle)" (click)="refresh()">Issues</button>
  </ng-container>
</h3>
<ng-container *ngIf="uploadFlag; else sendlabel" style="display:inline;">
  <upload-file (open_close)="receiveFlag($event)"></upload-file>
</ng-container>
<ng-template #sendlabel>
</ng-template>
<link href="https://fonts.googleapis.com/icon?family=Material+Icons&display=block" rel="stylesheet">
<div class="mat-app-background basic-container">
  <ng-container *ngIf="mastersheetFlag">
    <master-header>loading</master-header>
  </ng-container>
  <ng-container *ngIf="newleadsFlag">
    <newleads-header>loading</newleads-header>
  </ng-container>
   <ng-container *ngIf="ecmsFlag">
    <ecms-header>loading</ecms-header>
  </ng-container>
     <ng-container *ngIf="reportsFlag">
    <reports-header>loading</reports-header>
  </ng-container>
</div>
